import { api } from "..";

import { QueryProps } from "@/types/Api";
import {
  CreditFeature,
  CreditTier,
  CreateCreditTierPayload,
} from "@/types/CreditTier";

export interface CreateCreditTierParams {
  feature: CreditFeature;
  payload: CreateCreditTierPayload;
}

export const createCreditTier = async (
  props: QueryProps<CreateCreditTierParams>
): Promise<CreditTier> => {
  const res = await api.client.post("/credit-tiers", props.params.payload, {
    signal: props.signal,
    params: { feature: props.params.feature },
  });
  return res.data;
};
